import { render, staticRenderFns } from "./FilesDetailModal.vue?vue&type=template&id=0fdea4e8&"
import script from "./FilesDetailModal.vue?vue&type=script&lang=js&"
export * from "./FilesDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports